import React, { useCallback, useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { endpoint } from '../utils';
import { setLoading } from '../redux/actions/loader.action';

export default function ResetPasswordPage() {
  const jwt_access = localStorage.getItem('jwt_access');
  const { me } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {id, token} = useParams();

  const [showForm, setShowForm] = useState(false);
  const [password, setPassword] = useState("");
  const [isPasswordTouched, setIsPasswordTouched] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isConfirmPasswordTouched, setIsConfirmPasswordTouched] = useState(false);
  const [error, setError] = useState(null);

  const checkUserToken = useCallback(async() => {
    try {
      setShowForm(false);
      const { data } = await axios.get(`${ endpoint }api/auth/check-user-token/${ id }/${ token }`);
      console.log(data);
      setShowForm(true);
    } catch (err) {
      setError(err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message);
    }
  }, [id, token]);

  useEffect(() => {
    if(id && token && /^\d{1,}$/.test(id) && /^[a-z0-9-_]{60}$/i.test(token)){
      checkUserToken();
    }else{
      navigate('/login');
    }
  }, [id, token, location, navigate, checkUserToken]);

  const handleSubmit = async(e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setError(null);
    await axios.post(`${ endpoint }api/auth/reset-password/${ id }/${ token }`, {password}, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(({ data }) => {
                navigate('/login');
              })
              .catch((err) => {
                setError(err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message);
              })
              .finally(() => {
                dispatch(setLoading(false));
              });
  }

  useEffect(() => {
    if(jwt_access){
      navigate('/');
    }
  }, [location, navigate, jwt_access]);

  return (
    !me &&
    <HelmetProvider>
      <Helmet>
        <title>Changer votre mot de passe - Société Mikalo</title>
      </Helmet>

      <div id="authLogin">
        <form className='form login-form' onSubmit={ handleSubmit }>
          <div className='login-form-logo'>
            <img src="/images/logo.png" alt="" />
          </div>
          { showForm ? <>
            <div className='title'>
              <h1>Changer votre mot de passe</h1>
            </div>
            { error && <div className='alert alert-danger'>{ error }</div> }
            <div className='mb-3'>
              <label htmlFor='password' className='required'>Nouveau mot de passe</label>
              <input type='password' id='password' name='password' value={ password } onChange={ (e) => setPassword(e.target.value) } onBlur={ () => setIsPasswordTouched(true) } className='form-control' placeholder='Nouveau mot de passe' required autoComplete='off' />
              { isPasswordTouched && password.length === 0 && <div className='form-error'>Veuillez saisir votre nouveau mot de passe.</div> }
              { isPasswordTouched && password.length > 0 && password.length < 8 && <div className='form-error'>Votre mot de passe est trp court. Veuillez saisir au moins 8 caractères.</div> }
            </div>
            <div className='mb-3'>
              <label htmlFor='confirmPassword' className='required'>Confirmer votre mot de passe</label>
              <input type='password' id='confirmPassword' name='confirmPassword' value={ confirmPassword } onChange={ (e) => setConfirmPassword(e.target.value) } onBlur={ () => setIsConfirmPasswordTouched(true) } className='form-control' placeholder='Confirmer votre mot de passe' required autoComplete='off' />
              { password.length >= 8 && isConfirmPasswordTouched && confirmPassword.length === 0 && <div className='form-error'>Veuillez confirme votre mot de passe.</div> }
              { password.length >= 8 && isConfirmPasswordTouched && confirmPassword.length > 0 && password !== confirmPassword && <div className='form-error'>Votre mot de passe n'est pas correcte.</div> }
            </div>
            <div className='pt-1 mb-3'>
                <button type='submit' className='btn btn-primary w-100 btn-lg' disabled={
                  password.length < 8 || (password.length >= 0 && password !== confirmPassword)
                }>Enregistrer</button>
            </div>
          </> : error && <div className='alert alert-danger'>{ error }</div> }
          <div className='text-center'>
            <Link to="/login">Se connecter</Link>
          </div>
        </form>
      </div>
    </HelmetProvider>
  )
}
